import { campaignStates } from "../../../types/campaigns"
import { ICampaignProjectInfo } from "../../../components/ProjectGroups/projectGroups.helper"

export interface IGetSbCampaignsBody {
  fromDate: string
  toDate: string
  isManage: boolean
  filterType: SB_CAMPAIGNS_FILTER_TYPES
}

export enum SB_CAMPAIGNS_FILTER_TYPES {
  DATE = "Date",
  ORDERS = "Orders",
}

export interface IResultSbCampaigns {
  campaignsResult: ICampaignResult[]
  currentPageNo: number
  defaultBid: number
  defaultOrder: number
  defaultTargetAcos: IDefaultTargetAcos[]
  getAOVData: IGetAOVData | null
  lastDateWithoutData: string
  limitValue: number
  limitedCPCValue: ILimitedCPC | null
  maxTargetCPC: number
  minTargetCPC: number
  totalPages: number
  totalRecords: number
}

export interface ICampaignResult {
  acos: number
  campaignId: string
  campaignName: string
  campaignStatus: campaignStates
  clicks: number
  cpc: number
  ctr: number
  cvr: number
  impressions: number
  orders: number
  roas: number
  sales: number
  spend: number
  type: string
  units: number
  project?: ICampaignProjectInfo | null
}

export interface IDefaultTargetAcos {
  _id: string
  customerId: string
  type: string
  createdAt: string
  profileId: number
  targetAcos: number
  updatedAt: string
  campaignType: string
  dynamicTarget: boolean
  dynamicTargetAcos: IDynamicTargetAcos[]
}

export interface IDynamicTargetAcos {
  from: number
  to: number
  Acos: number
  _id: string
}

export interface IGetAOVData {
  aovs: {
    campaignName: string
    value: number
    cogs: number
    _id: string
  }[]
  createdAt: string
  customerId: string
  profileId: number
  updatedAt: string
  _id: string
}

export interface ILimitedCPC {
  conditions: {
    fieldName: string
    from: number
    to: number
    increaseBid: number
    decreaseBid: number
  }[]
  createdAt: string
  customerId: string
  profileId: number
  updatedAt: string
  _id: string
}

export interface IUpdateCampaignParams {
  stateByCampaignIds: { campaignId: string; state: campaignStates }[]
}

export interface IUpdateSbTarget {
  targetData: ITargetDataForUpdate[]
}

export interface ITargetDataForUpdate {
  campaignId: string
  targetId: string
  adGroupId: string
  bid: number
  oldBid?: number
  targetName: string
}

export interface IStateByCampaignIds {
  campaignId: string
  state: campaignStates
}

export interface IUpdateCampaignResult {
  success: string[]
  error: string[]
}
